export interface Pill {
  id: string;
  label: string;
}

export enum HeaderOption {
  EDIT = 'edit',
}

export enum BaselineId {
  CONSENTED = 'consented',
  INTERESTED = 'interested',
}

export enum DateSort {
  DAY = 'day',
  WEEK = 'week',
}

export enum LayoutOneDateRangeOptionId {
  THIS_QUARTER = 'this_quarter',
  LAST_QUARTER = 'last_quarter',
  THIS_YEAR = 'this_year',
  LAST_YEAR = 'last_year',
  ALL_TIME = 'all_time',
}

export const LAYOUT_NUMBER = 1;

export enum PillId {
  CONSENTED_PARTICIPANTS = 'consented_participants',
  CAMPAIGN_TRACKING = 'campaign_tracking',
}
